$(document).ready(function() {
    $('.action-slideshow-slider').slick({
      infinite: true,
      centerMode: true,
      centerPadding: '150px',
      slidesToShow: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerPadding: '40px',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 475,
          settings: {
            centerPadding: '0px',
            slidesToShow: 1
          }
        }
      ]
    });
});